window.addEventListener("DOMContentLoaded", function () {
  const productEl = document.querySelector(".product-template-container");

  const DOM = {
    productBundleEl: productEl?.querySelector("product-bundle-info"),

    totalPriceEl: productEl?.querySelector(".product-single__price"),

    compareTotalEl: productEl?.querySelector(
      ".product-single__price--compare-at"
    ),

    addCartEl: productEl?.querySelector(".custom_add_to_cart"),

    buyCartEl: productEl?.querySelector(".custom-buy-now-btn"),

    currentEl: null,

    currentType: "cart",

    // 价格状态
    originPrice: 0,

    originComparePrice: 0,

    currentAccessoryPrice: 0,

    currentAccessoryComparePrice: 0,

    bottomBar: document.querySelector(
      ".common-tabbar-bottom-purchase-bar"
    ),

    bottomBarColorEl: null,

    bottomBarPriceEl: null,

    bottomBarCompareEl: null,

    bottomBarDiscountEl: null,

    productDiscountEl: productEl?.querySelector(
      ".show-discount .discount-percent"
    ),

    bottomBarIdInput: null,

    bottomAddCartEl: document.querySelector(
      ".common-tabbar-bottom-purchase-bar .add-to-cart-btn-custom"
    ),

    bottomBuyNowEl: document.querySelector(
      ".common-tabbar-bottom-purchase-bar .buy-now-btn-custom"
    ),
  };


  /*
   * ==========================================================
   * 底部栏事件
   * ==========================================================
   */
  function bindBottomBarCartEvent() {
    if (!DOM.bottomBar) return;

    if (DOM.bottomBar.dataset.bindCart === "1") return;

    DOM.bottomBar.dataset.bindCart = "1";


    DOM.bottomBar.addEventListener("click", (e) => {
      const btn = e.target.closest(
        ".common-tabbar-bottom-purchase-bar [data-action]"
      );

      if (!btn) return;


      e.preventDefault();

      e.stopPropagation();


      const action = btn.dataset.action;


      if (action === "cart") {

        // 触发商品头 Add to Cart 按钮
        const topAddCartBtn =
          productEl?.querySelector(".custom_add_to_cart");


        if (!topAddCartBtn) {
          console.error(
            "未找到商品头 Add to Cart 按钮"
          );

          return;
        }


        topAddCartBtn.click();

        return;
      }


      if (action === "buy") {

        const productForm =
          productEl?.querySelector(
            "[data-product-form]"
          );


        if (!productForm) {

          console.error("未找到商品表单");

          return;
        }


        // 找到顶部 Buy Now 按钮
        const buyBtn =
          productForm.querySelector(
            ".custom-buy-now-btn"
          );


        if (buyBtn) {

          buyBtn.click();

          return;
        }
      }
    });
  }


  /*
   * ==========================================================
   * 初始化产品基础价格
   * ==========================================================
   */
  function initProductBasePrice() {

    if (!DOM.totalPriceEl) return;


    const salePrice =
      DOM.totalPriceEl.getAttribute("content") ||
      "0";


    const comparePrice =
      DOM.compareTotalEl?.getAttribute("content") ||
      salePrice;


    DOM.originPrice =
      Number(salePrice) * 100;


    DOM.originComparePrice =
      Number(comparePrice) * 100;
  }


  /*
   * ==========================================================
   * 初始化底部栏元素引用
   * ==========================================================
   */
  function initBottomBarRefs() {

    const bar = DOM.bottomBar;


    console.group("🟢 initBottomBarRefs");

    console.groupEnd();


    if (!bar) return;


    bar.classList.add("show");


    DOM.bottomBarColorEl =
      bar.querySelector(".color-value");


    DOM.bottomBarPriceEl =
      bar.querySelector(".current-price");


    DOM.bottomBarCompareEl =
      bar.querySelector(".compare-price");


    DOM.bottomBarDiscountEl =
      bar.querySelector(".discount-badge");


    DOM.bottomBarIdInput =
      bar.querySelector('input[name="id"]');
  }


  /*
   * ==========================================================
   * 更新底部栏价格显示
   * ==========================================================
   */
  function updateBottomBarDisplay(
    finalTotal,
    finalCompareTotal
  ) {

    const bar = DOM.bottomBar;


    if (
      !bar ||
      !DOM.bottomBarPriceEl
    ) {

      return;
    }


    const formatMoney =

      window.theme?.Currency?.formatMoney ||

      ((price, format) => {

        const amount =
          (price / 100).toFixed(2);


        return format
          ? format.replace(
              "{{ amount }}",
              amount
            )
          : `$${amount}`;
      });


    const formattedTotal =
      formatMoney(
        finalTotal,
        window.theme?.strings?.moneyFormat
      );


    DOM.bottomBarPriceEl.textContent =
      formattedTotal;


    /*
     * compare price + discount
     */
    if (finalCompareTotal > finalTotal) {

      if (DOM.bottomBarCompareEl) {

        DOM.bottomBarCompareEl.textContent =
          formatMoney(
            finalCompareTotal,
            window.theme?.strings?.moneyFormat
          );


        DOM.bottomBarCompareEl.style.display =
          "inline";
      }


      const dis =
        Math.ceil(
          (
            (
              finalCompareTotal -
              finalTotal
            ) *
            100
          ) /
          finalCompareTotal
        );


      if (DOM.bottomBarDiscountEl) {

        DOM.bottomBarDiscountEl.textContent =
          `${dis}% OFF`;


        DOM.bottomBarDiscountEl.style.display =
          "inline-block";
      }


      if (DOM.productDiscountEl) {

        DOM.productDiscountEl.textContent =
          `${dis}%`;
      }

    } else {

      if (DOM.bottomBarCompareEl) {

        DOM.bottomBarCompareEl.style.display =
          "none";
      }


      if (DOM.bottomBarDiscountEl) {

        DOM.bottomBarDiscountEl.style.display =
          "none";
      }
    }


    DOM.bottomBarPriceEl.setAttribute(
      "aria-label",
      "Sale price: " +
        formattedTotal +
        " US dollars"
    );


    /*
     * 防止 compare element 不存在时报错
     */
    if (DOM.bottomBarCompareEl) {

      DOM.bottomBarCompareEl.setAttribute(
        "aria-label",
        "Original price: " +
          formatMoney(
            finalCompareTotal,
            window.theme?.strings?.moneyFormat
          ) +
          " US dollars"
      );
    }


    /*
     * ID 同步
     */
    const id =
      DOM.addCartEl?.getAttribute("data-id");


    if (
      DOM.bottomBarIdInput &&
      id
    ) {

      DOM.bottomBarIdInput.value = id;
    }
  }


  /*
   * ==========================================================
   * 更新底部栏变体颜色
   * ==========================================================
   */
  function updateBottomBarColorByVariant(
    variant
  ) {

    if (
      !DOM.bottomBarColorEl ||
      !variant
    ) {

      return;
    }


    const color =
      variant.options?.[0];


    DOM.bottomBarColorEl.textContent =
      color === "Default Title"
        ? ""
        : color || "";
  }


  /*
   * ==========================================================
   * 监听配件价格变化
   * ==========================================================
   */
  function bindAccessoryPriceEvent() {

    document.addEventListener(
      "accessory:priceChange",
      (e) => {

        console.group(
          "🟡 accessory:priceChange"
        );

        console.groupEnd();


        const {
          accessoryPrice = 0,
          accessoryComparePrice = 0,
        } = e.detail || {};


        DOM.currentAccessoryPrice =
          accessoryPrice;


        DOM.currentAccessoryComparePrice =
          accessoryComparePrice;


        updatePriceDisplay();
      }
    );
  }


  /*
   * ==========================================================
   * 更新主价格显示
   * ==========================================================
   */
  function updatePriceDisplay() {

    console.group(
      "💰 updatePriceDisplay"
    );


    if (!DOM.totalPriceEl) {

      console.groupEnd();

      return;
    }


    const {
      total: finalTotal,
      compareTotal: finalCompareTotal,
    } = calculateTotalPrice();


    const formatMoney =

      window.theme?.Currency?.formatMoney ||

      ((price, format) => {

        const amount =
          (price / 100).toFixed(2);


        return format
          ? format.replace(
              "{{ amount }}",
              amount
            )
          : `$${amount}`;
      });


    const formattedTotal =
      formatMoney(
        finalTotal,
        window.theme?.strings?.moneyFormat
      );


    const formattedCompare =
      formatMoney(
        finalCompareTotal,
        window.theme?.strings?.moneyFormat
      );


    /*
     * ======================================================
     * 更新售价
     * ======================================================
     */
    DOM.totalPriceEl.textContent =
      formattedTotal;


    /*
     * 同时更新 content。
     *
     * 防止其他主题 JS 后续继续从 content
     * 获取旧的主商品价格。
     */
    DOM.totalPriceEl.setAttribute(
      "content",
      (finalTotal / 100).toFixed(2)
    );


    /*
     * ======================================================
     * 更新划线价
     * ======================================================
     */
    if (finalCompareTotal > finalTotal) {

      if (DOM.compareTotalEl) {

        DOM.compareTotalEl.textContent =
          formattedCompare;


        DOM.compareTotalEl.setAttribute(
          "content",
          (
            finalCompareTotal / 100
          ).toFixed(2)
        );

      } else {

        const compareEl =
          document.createElement("span");


        compareEl.className =
          "product-single__price--compare-at";


        compareEl.textContent =
          formattedCompare;


        compareEl.setAttribute(
          "content",
          (
            finalCompareTotal / 100
          ).toFixed(2)
        );


        DOM.totalPriceEl.after(compareEl);


        DOM.compareTotalEl =
          compareEl;
      }

    } else if (DOM.compareTotalEl) {

      DOM.compareTotalEl.remove();

      DOM.compareTotalEl = null;
    }


    console.groupEnd();


    updateBottomBarDisplay(
      finalTotal,
      finalCompareTotal
    );
  }


  /*
   * ==========================================================
   * 获取原始主商品 Bundle Item
   * ==========================================================
   *
   * product-bundle-info.js 中保存的 bundleItems
   * 是 DOM 换位之前产生的 Static NodeList。
   *
   * 所以：
   *
   * bundleItems[0]
   *
   * 永远是原来的 PDP 主商品。
   * ==========================================================
   */
  function getOriginalMainBundleItem() {

    if (!DOM.productBundleEl) {

      return null;
    }


    /*
     * 优先使用 product-bundle-info.js
     * 保存的原始 NodeList。
     */
    if (
      DOM.productBundleEl.bundleItems &&
      DOM.productBundleEl.bundleItems.length >
        0
    ) {

      return DOM.productBundleEl.bundleItems[0];
    }


    /*
     * 兜底
     */
    const items =
      DOM.productBundleEl.querySelectorAll(
        ".bundle-item"
      );


    if (!items.length) {

      return null;
    }


    const isPriority =
      DOM.productBundleEl.getAttribute(
        "data-ams-priority-bundle"
      ) === "true";


    /*
     * Priority=true 时，
     * JS 已经把原第二个移动到了 DOM 第一位。
     *
     * 此时原主商品就在第二位。
     */
    if (
      isPriority &&
      items.length > 1
    ) {

      return items[1];
    }


    return items[0];
  }


  /*
   * ==========================================================
   * 获取当前 active Bundle 完整信息
   * ==========================================================
   */
  function getActiveBundleInfo() {

    if (!DOM.productBundleEl) {

      return null;
    }


    const activeItem =
      DOM.productBundleEl.querySelector(
        ".bundle-item.active"
      );


    if (!activeItem) {

      return null;
    }


    const originalMainItem =
      getOriginalMainBundleItem();


    const isMainProduct =
      originalMainItem
        ? activeItem === originalMainItem
        : false;


    const itemPriceEl =
      activeItem.querySelector(
        ".bundle-on-sale"
      );


    const itemPrice =
      itemPriceEl
        ? Number(
            itemPriceEl.getAttribute(
              "data-content"
            )
          )
        : 0;


    const comparePriceEl =
      activeItem.querySelector(
        ".bundle-compare-at"
      );


    const comparePrice =
      comparePriceEl
        ? Number(
            comparePriceEl.getAttribute(
              "data-content"
            )
          )
        : itemPrice;


    const id =
      activeItem.getAttribute("data-id");


    const rawColor =

      activeItem.getAttribute(
        "data-color"
      ) ||

      activeItem
        .querySelector(".bundle-color")
        ?.textContent?.trim() ||

      "";


    const color =
      rawColor === "Default Title"
        ? ""
        : rawColor || "";


    return {

      activeItem,

      isMainProduct,

      itemPrice,

      comparePrice,

      id,

      color,
    };
  }


  /*
   * ==========================================================
   * 同步当前 active Bundle
   * ==========================================================
   *
   * 这里只主动同步真正的 Bundle 商品。
   *
   * 如果当前 active 是原主商品，
   * 不强制使用 Liquid 初始化 ID，
   * 防止覆盖用户当前选择的真实 Variant。
   * ==========================================================
   */
  function syncActiveBundleInfo(
    updatePrice = true
  ) {

    const bundleInfo =
      getActiveBundleInfo();


    if (!bundleInfo) {

      return false;
    }


    /*
     * 当前是原 PDP 主商品
     *
     * 保持原来的 Variant 逻辑。
     */
    if (bundleInfo.isMainProduct) {

      return false;
    }


    const {
      itemPrice,
      comparePrice,
      id,
      color,
    } = bundleInfo;


    if (!id) {

      return false;
    }


    /*
     * 同步真正选中的 Bundle ID
     */
    changeCartAndBuyId(
      id,
      itemPrice,
      comparePrice
    );


    /*
     * 同步价格
     */
    if (updatePrice) {

      DOM.originPrice =
        itemPrice;


      DOM.originComparePrice =
        comparePrice;


      if (DOM.bottomBarColorEl) {

        DOM.bottomBarColorEl.textContent =
          color;
      }


      updatePriceDisplay();
    }


    return true;
  }


  /*
   * ==========================================================
   * 处理 Bundle 变化
   * ==========================================================
   */
  function handleBundleInfoChange(e) {

    console.group(
      "🟡 bundle:InfoChange"
    );

    console.groupEnd();


    const {
      itemPrice = 0,
      comparePrice = 0,
      id = null,
      color = "",
    } = e.detail || {};


    DOM.originPrice =
      itemPrice;


    DOM.originComparePrice =
      comparePrice;


    /*
     * 同步：
     *
     * Add To Cart
     * Buy Now
     * data price
     */
    changeCartAndBuyId(
      id,
      itemPrice,
      comparePrice
    );


    if (DOM.bottomBarColorEl) {

      DOM.bottomBarColorEl.textContent =
        color;
    }


    updatePriceDisplay();
  }


  /*
   * ==========================================================
   * 绑定 Bundle 价格事件
   * ==========================================================
   */
  function bindBundlePriceEvent() {

    if (!DOM.productBundleEl) {

      return;
    }


    /*
     * 先移除旧事件避免重复绑定
     */
    DOM.productBundleEl.removeEventListener(
      "bundle:InfoChange",
      handleBundleInfoChange
    );


    DOM.productBundleEl.addEventListener(
      "bundle:InfoChange",
      handleBundleInfoChange
    );


    /*
     * ======================================================
     * 关键修复
     * ======================================================
     *
     * product-bundle-info.js 可能已经在这里之前
     * 把第二个 Bundle 设置为了 active。
     *
     * 但是之前 dispatch 的 bundle:InfoChange
     * 有可能发生在当前监听器绑定之前。
     *
     * 所以监听器绑定完成以后，
     * 主动读取一次当前 active。
     * ======================================================
     */
    syncActiveBundleInfo(true);
  }


  /*
   * ==========================================================
   * 计算总价
   * ==========================================================
   */
  function calculateTotalPrice() {

    console.group(
      "🔢 calculateTotalPrice"
    );


    const result = {

      total:
        DOM.originPrice +
        DOM.currentAccessoryPrice,

      compareTotal:
        DOM.originComparePrice +
        DOM.currentAccessoryComparePrice,

    };


    console.groupEnd();


    return result;
  }


  /*
   * ==========================================================
   * 更新无库存状态
   * ==========================================================
   */
  function updateVariantAvailable(
    available
  ) {

    const buyNowButton =
      DOM.buyCartEl;


    if (buyNowButton) {

      available
        ? buyNowButton.classList.remove(
            "custom-buy-now-btn-sold-out"
          )
        : buyNowButton.classList.add(
            "custom-buy-now-btn-sold-out"
          );
    }
  }


  /*
   * ==========================================================
   * 监听主题 Variant 变化
   * ==========================================================
   */
  function bindVariantPriceChangeFromTheme() {

    document.addEventListener(
      "variant:change",
      (ev) => {

        console.group(
          "🟡 variant:change"
        );

        console.groupEnd();


        const { variant } =
          ev.detail || {};


        if (!variant) {

          return;
        }


        /*
         * ==================================================
         * Priority Bundle 核心修复
         * ==================================================
         *
         * 如果当前 active 的不是原 PDP 主商品，
         * 而是真正的 Bundle，
         *
         * 那么主题自己的 variant:change
         * 不能再把：
         *
         * price
         * compare price
         * variant id
         *
         * 覆盖回原来的 PDP 商品。
         *
         * 否则就会出现：
         *
         * 页面 Bundle 是 active
         * 但价格又变回主商品
         * Add To Cart 又变回主商品。
         * ==================================================
         */
        const activeBundleInfo =
          getActiveBundleInfo();


        if (
          activeBundleInfo &&
          !activeBundleInfo.isMainProduct
        ) {

          DOM.originPrice =
            activeBundleInfo.itemPrice;


          DOM.originComparePrice =
            activeBundleInfo.comparePrice;


          changeCartAndBuyId(
            activeBundleInfo.id,
            activeBundleInfo.itemPrice,
            activeBundleInfo.comparePrice
          );


          if (DOM.bottomBarColorEl) {

            DOM.bottomBarColorEl.textContent =
              activeBundleInfo.color;
          }


          updatePriceDisplay();


          /*
           * 当前 Bundle 仍然保持选中，
           * 不允许主商品 variant
           * 覆盖当前 Bundle。
           */
          return;
        }


        /*
         * ==================================================
         * 以下保持原来的主商品 Variant 逻辑
         * ==================================================
         */


        // 更新加入购物车按钮的变体 ID
        changeCartAndBuyId(
          variant.id,
          variant.price,
          variant.compare_at_price
        );


        const price =
          variant.price;


        const compare =
          variant.compare_at_price;


        DOM.originPrice =
          price;


        DOM.originComparePrice =
          compare || price;


        updatePriceDisplay();


        updateBottomBarColorByVariant(
          variant
        );


        updateVariantAvailable(
          variant.available
        );
      }
    );
  }


  /*
   * ==========================================================
   * 更新购物车按钮 / Buy Now Variant ID
   * ==========================================================
   *
   * 在原来的 ID 同步基础上，
   * 同时同步 price data。
   *
   * 这样其他依赖按钮 data price
   * 的逻辑不会继续读到旧主商品价格。
   * ==========================================================
   */
  function changeCartAndBuyId(
    id,
    price = null,
    comparePrice = null
  ) {

    if (!id) {

      return;
    }


    if (DOM.addCartEl) {

      DOM.addCartEl.setAttribute(
        "data-id",
        id
      );


      if (price !== null) {

        DOM.addCartEl.setAttribute(
          "data-on_sale_price",
          price
        );
      }


      if (
        comparePrice !== null &&
        Number(comparePrice) >
          Number(price)
      ) {

        DOM.addCartEl.setAttribute(
          "data-compare_at_price",
          comparePrice
        );

      } else if (
        comparePrice !== null
      ) {

        DOM.addCartEl.removeAttribute(
          "data-compare_at_price"
        );
      }
    }


    if (DOM.buyCartEl) {

      DOM.buyCartEl.setAttribute(
        "data-id",
        id
      );


      if (price !== null) {

        DOM.buyCartEl.setAttribute(
          "data-on_sale_price",
          price
        );
      }


      if (
        comparePrice !== null &&
        Number(comparePrice) >
          Number(price)
      ) {

        DOM.buyCartEl.setAttribute(
          "data-compare_at_price",
          comparePrice
        );

      } else if (
        comparePrice !== null
      ) {

        DOM.buyCartEl.removeAttribute(
          "data-compare_at_price"
        );
      }
    }


    /*
     * 底部购买栏同步 ID
     */
    if (DOM.bottomBarIdInput) {

      DOM.bottomBarIdInput.value = id;
    }
  }


  /*
   * ==========================================================
   * 加入购物车逻辑
   * ==========================================================
   */
  async function addOneToCart(
    variants
  ) {

    if (!DOM.currentEl) return;


    // 显示加载状态
    DOM.currentEl.classList.add(
      "loading"
    );


    const root =
      window.Shopify?.routes?.root ||
      "/";


    let mainProductAdded = false;


    const failedAccessories = [];


    try {

      for (
        let i = 0;
        i < variants.length;
        i++
      ) {

        const {
          id,
          quantity
        } = variants[i];


        if (
          !id ||
          quantity <= 0
        ) {

          continue;
        }


        const response =
          await fetch(
            `${root}cart/add.js`,
            {

              method: "POST",

              headers: {

                "Content-Type":
                  "application/json",

                Accept:
                  "application/json",

              },

              body: JSON.stringify({

                id,

                quantity,

              }),

            }
          );


        if (!response.ok) {

          let errorMessage =
            `HTTP ${response.status}`;


          try {

            const errorData =
              await response.json();


            errorMessage =
              errorData.description ||
              errorData.message ||
              errorMessage;

          } catch (error) {

            // 无法解析 Shopify 错误内容时，
            // 保留默认错误信息

          }


          /*
           * variants[0] 是主购买商品。
           */
          if (i === 0) {

            throw new Error(
              errorMessage
            );
          }


          /*
           * 后面的商品是配件。
           */
          console.warn(
            `配件 ${id} 添加失败，已跳过：${errorMessage}`
          );


          failedAccessories.push({

            id,

            quantity,

            message:
              errorMessage,

          });


          continue;
        }


        await response.json();


        if (i === 0) {

          mainProductAdded =
            true;
        }


        if (
          i <
          variants.length - 1
        ) {

          await new Promise(
            (resolve) =>
              setTimeout(
                resolve,
                200
              )
          );
        }
      }


      /*
       * 主商品没有成功加入
       */
      if (!mainProductAdded) {

        throw new Error(
          "主商品未能成功加入购物车"
        );
      }


      const cartRes =
        await fetch(
          `${root}cart.js`,
          {

            headers: {

              Accept:
                "application/json",

            },

          }
        );


      if (!cartRes.ok) {

        throw new Error(
          "购物车信息读取失败"
        );
      }


      const cart =
        await cartRes.json();


      if (
        cart &&
        window.CartApi &&
        typeof window.CartApi
          .notifyTimberCartUpdated ===
          "function"
      ) {

        try {

          await window.CartApi
            .notifyTimberCartUpdated(
              cart,
              {
                source:
                  "section_product_template_add",
              }
            );

        } catch (e) {

          console.error(
            "处理购物车赠品时出错:",
            e
          );
        }
      }


      if (
        window.updateStepCartGift
      ) {

        await window.updateStepCartGift(
          cart
        );
      }


      /*
       * 配件失败只记录控制台
       */
      if (
        failedAccessories.length >
        0
      ) {

        console.warn(
          "以下配件因库存不足或当前市场不可售而未加入购物车：",
          failedAccessories
        );
      }


      const type =
        DOM.currentType;


      if (type === "checkout") {

        window.location.href =
          `${root}checkout`;

      } else {

        const cartDrawerBtn =
          document.querySelector(
            ".js-drawer-open-button-right"
          );


        if (cartDrawerBtn) {

          cartDrawerBtn.click();

        } else {

          window.location.href =
            `${root}cart`;
        }
      }

    } catch (error) {

      console.error(
        "主商品添加到购物车失败：",
        error
      );


      /*
       * 只有主商品失败时提示
       */
      alert(
        error.message ||
          "商品添加失败，请稍后重试。"
      );

    } finally {

      DOM.currentEl.classList.remove(
        "loading"
      );
    }
  }


  /*
   * ==========================================================
   * 绑定加入购物车按钮事件
   * ==========================================================
   */
  function bindCartEvent() {

    if (
      !DOM.addCartEl &&
      !DOM.buyCartEl
    ) {

      return;
    }


    if (DOM.addCartEl) {

      DOM.addCartEl.addEventListener(
        "click",
        () => {

          changeCurrentInfo(
            DOM.addCartEl,
            "cart"
          );


          bindQtyCartEvent();
        }
      );
    }


    if (DOM.buyCartEl) {

      DOM.buyCartEl.addEventListener(
        "click",
        (event) => {

          event.preventDefault();


          changeCurrentInfo(
            DOM.buyCartEl,
            "checkout"
          );


          bindQtyCartEvent();
        }
      );
    }
  }


  /*
   * ==========================================================
   * 当前按钮
   * ==========================================================
   */
  function changeCurrentInfo(
    el,
    type
  ) {

    DOM.currentEl = el;

    DOM.currentType = type;
  }


  /*
   * ==========================================================
   * 获取购买商品及配件
   * ==========================================================
   */
  function bindQtyCartEvent() {

    console.group(
      "🛒 bindQtyCartEvent"
    );


    /*
     * ======================================================
     * 最终加购前兜底
     * ======================================================
     *
     * 再读取一次当前 active Bundle。
     *
     * 即使初始化事件因为加载顺序被漏掉，
     * 真正加购之前也一定会同步当前 Bundle ID。
     *
     * 当前如果是主商品，
     * 不会覆盖主商品真实 Variant。
     * ======================================================
     */
    syncActiveBundleInfo(false);


    const qtyInput =
      productEl?.querySelector(
        "[data-product-form] .product-single__quantity .js-qty__num"
      );


    const productQty =
      qtyInput
        ? Math.max(
            1,
            parseInt(
              qtyInput.value
            ) || 1
          )
        : 1;


    /*
     * 当前真正需要加入购物车的主商品 / Bundle
     */
    const baseItem = {

      id:
        DOM.addCartEl?.getAttribute(
          "data-id"
        ),

      quantity:
        productQty,

    };


    const accessoryItems = [];


    document
      .querySelectorAll(
        ".header-case-content .js-case-qty__num"
      )
      .forEach(
        (input) => {

          const qty =
            Math.max(
              0,
              parseInt(
                input.value
              ) || 0
            );


          if (qty > 0) {

            accessoryItems.push({

              id:
                input.dataset.id,

              product_id:
                input.dataset.productId,

              quantity:
                qty,

            });
          }
        }
      );


    const allItems = [

      baseItem,

      ...accessoryItems,

    ];


    if (allItems.length > 0) {

      console.groupEnd();


      addOneToCart(
        allItems
      );
    }
  }


  /*
   * ==========================================================
   * Priority Bundle 首屏最终同步
   * ==========================================================
   *
   * 用 requestAnimationFrame 再同步一次，
   * 防止主题其他初始化脚本首屏把价格改回原商品。
   *
   * 只有 Priority=true 时执行。
   * ==========================================================
   */
  function syncPriorityBundleAfterInit() {

    if (!DOM.productBundleEl) {

      return;
    }


    const isPriorityBundle =
      DOM.productBundleEl.getAttribute(
        "data-ams-priority-bundle"
      ) === "true";


    if (!isPriorityBundle) {

      return;
    }


    /*
     * 当前立即同步
     */
    syncActiveBundleInfo(true);


    /*
     * 下一帧再兜底一次
     */
    requestAnimationFrame(
      () => {

        syncActiveBundleInfo(true);

      }
    );
  }


  /*
   * ==========================================================
   * 初始化所有功能
   * ==========================================================
   */
  function init() {

    console.group("🟢 INIT()");

    console.groupEnd();


    /*
     * 先拿到底部条节点
     */
    initBottomBarRefs();


    /*
     * 初始化主商品价格
     */
    initProductBasePrice();


    /*
     * Bundle
     */
    bindBundlePriceEvent();


    /*
     * 配件
     */
    bindAccessoryPriceEvent();


    /*
     * Variant
     */
    bindVariantPriceChangeFromTheme();


    /*
     * Cart
     */
    bindCartEvent();


    /*
     * Bottom Bar
     */
    bindBottomBarCartEvent();


    /*
     * 当前价格首屏同步
     */
    updatePriceDisplay();


    /*
     * Priority Bundle 最终兜底
     */
    syncPriorityBundleAfterInit();
  }


  init();
});